import React, { useContext, useEffect, useState } from 'react';
import { Layout, Menu, Row, notification } from 'antd';
import {
  HomeOutlined,
  UserOutlined,
  SolutionOutlined,
  ClusterOutlined,
  LockOutlined,
} from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { useIntl } from 'react-intl';
import { onMessageListener } from '../firebase';
import Profile from '../profile/index';
import { StoreContext } from '../store/index';
import Requests from '../requests/index';
import './index.css';

function LayoutMenu({ children }) {
  const store = useContext(StoreContext);
  const {
    user: [user, setUser],
  } = store;
  const { formatMessage } = useIntl();
  const navigate = useNavigate();
  const { Content, Footer } = Layout;
  const [api, contextHolder] = notification.useNotification();
  const [message, setMessage] = useState(null);

  const buttons = [
    {
      key: 'news',
      label: formatMessage({
        id: 'layout.news',
      }),
      icon: <SolutionOutlined />,
      onClick: () => navigate('/news'),
    },
    {
      key: 'misPartidos',
      label: formatMessage({
        id: 'layout.games',
      }),
      icon: <HomeOutlined />,
      onClick: () => navigate('/'),
    },
    {
      key: 'profile',
      label: formatMessage({
        id: 'layout.profile',
      }),
      icon: <UserOutlined />,
      onClick: () => navigate('/profile'),
    },
  ];

  const [layoutButtons, setLayoutButtons] = useState(buttons);

  const openNotification = () => {
    api.open({
      message: message.title,
      description: message.body,
    });
  };

  useEffect(() => {
    if (message) {
      openNotification();
    }
    if (user.isAdmin) {
      setLayoutButtons([
        {
          key: 'admin',
          label: formatMessage({
            id: 'layout.admin',
          }),
          icon: <LockOutlined />,
          onClick: () => navigate('/admin'),
        },
        ...buttons,
      ]);
    }
  }, [message]);

  onMessageListener()
    .then(payload => {
      setMessage({
        title: payload?.notification?.title,
        body: payload?.notification?.body,
        url: payload?.notification?.url,
      });
    })
    .catch(err => console.log('failed: ', err));

  return (
    <Layout className="site-layout">
      {contextHolder}
      <Content
        style={{
          marginBottom: '40px',
        }}>
        {children}
      </Content>
      <Footer
        style={{
          borderTop: '1px solid #e8e8e8',
          position: 'fixed',
          left: 0,
          bottom: 0,
          width: '100%',
          backgroundColor: 'white',
          textAlign: 'center',
          padding: '0px',
        }}>
        <Row justify="center">
          <Menu
            style={{ width: '100%', justifyContent: 'center' }}
            defaultSelectedKeys={['1']}
            mode="horizontal"
            items={layoutButtons}
          />
        </Row>
      </Footer>
    </Layout>
  );
}

export default LayoutMenu;
